import { Component, OnInit, Input } from '@angular/core';
import { SetDeptComponent } from '../../set-dept/set-dept.component';
import { MatDialog } from '@angular/material';
import { CurrentService, ElementsService, eleSwitchDept } from 'dbweb-core';

@Component({
	selector: 'common-nav-selection-dept',
	templateUrl: './nav-selection-dept.component.html',
	styleUrls: ['./nav-selection-dept.component.scss']
})
export class NavSelectionDeptComponent implements OnInit {
	@Input() isMinNav: boolean;
	constructor(public dialog: MatDialog, public eles: ElementsService, public current: CurrentService) {}

	ngOnInit() {}
	customDept() {
		const dialogRef = this.dialog.open(SetDeptComponent, {
			width: '250px'
		});
		dialogRef.afterClosed().subscribe(() => {
			console.log('The dialog was closed');
		});
	}
	switchDept(code: string) {
		// å¿é¡»è°ç¨subscribeï¼å¦åä¸ä¼è¿è¡
		this.current.switchDept(code, this.eles.get(eleSwitchDept).SignStr).subscribe();
	}
}
